<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Regions</h5>
                </div>
                <div class="card-body">
                    
                    <div class="btn-popup pull-right">
                        <button type="button" class="btn btn-primary" data-toggle="modal" data-original-title="test"
                            data-target="#exampleModal" (click)="open()">Add Service Provider Group</button>                      
                    </div>
                    <app-region-management-list></app-region-management-list>
                </div>
            </div>
        </div>
    </div>
</div>
<app-service-provider-group-modal #serviceProviderGroupModal [addOrEdit]="'Add'" [restaurantId]="selectedId"></app-service-provider-group-modal>
<!-- Container-fluid Ends-->